import React from "react";
import { Navigate } from "react-router-dom";
import Layout from './Layout/Layout';
import PreLoader from './Layout/PreLoader/PreLoader';
import { isAuthenticated, getUserSession } from "../../util/core/Session";

import { VerifyPermission } from "../../util/core/VerifyPermission";

function RestrictedArea({ content }) {
  if (isAuthenticated()) {
    // VerifyPermission();
    return (
      <div>
        <Layout content={content} />
      </div>
    );
  } else {
    return (
      <div>
        <Navigate to="/login" />
      </div>
    );
  }
}
export default RestrictedArea;
